<bzg-modal-header>
    <span class="bz-modal__title">{{'RPA_BOTS.QUEUEITEM_DETAIL_TITLE' | translate }}</span>
    <bzg-button-icon [icon]="'icon-close'" size="l" [bzgModalClose]="{trigger: 'close'}">
    </bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <form>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.QUEUE_NAME' | translate }}:
        </h4>
        <p>
            {{initialData.QueueDefinition.Name}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.SPECIFIC_DATA' | translate }}:
        </h4>
        <div class="json-content">
            <ngx-json-viewer class="bz-json-viewer" *ngIf="specificData" [json]="specificData" [expanded]="true">
            </ngx-json-viewer>
            <p *ngIf="!specificData">
                {{'RPA_BOTS.NO_SPECIFIC_DATA' | translate }}.
            </p>
        </div>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.DEADLINE' | translate }}:
        </h4>
        <p>
            {{initialData.DueDate}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.POSTPONE' | translate }}:
        </h4>
        <p>
            {{initialData.DeferDate}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.REFERENCE' | translate }}:
        </h4>
        <p>
            {{initialData.Reference}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.EXCEPTION' | translate }}:
        </h4>
        <h5 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.EXCEPTION_REASON' | translate }}:
        </h5>
        <span>
            {{initialData.ProcessingException.Reason}}
        </span>
        <h5 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.EXCEPTION_DETAILS' | translate }}:
        </h5>
        <span>
            {{initialData.ProcessingException.Details}}
        </span>
        <h5 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.EXCEPTION_TYPE' | translate }}:
        </h5>
        <span>
            {{initialData.ProcessingException.Type}}
        </span>
    </form>
</bzg-modal-content>